import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ls_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("ls_cart", JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((asset, license = "standard") => {
    setItems((prev) => {
      if (prev.some((i) => i.id === asset.id)) return prev;
      const price = license === "commercial" ? asset.price * 3 : asset.price;
      return [
        ...prev,
        {
          id: asset.id,
          title_id: asset.title_id,
          title_en: asset.title_en,
          preview_url: asset.preview_url,
          license,
          price,
          basePrice: asset.price,
        },
      ];
    });
  }, []);

  const removeItem = useCallback((id) => {
    setItems((prev) => prev.filter((i) => i.id !== id));
  }, []);

  const setLicense = useCallback((id, license) => {
    setItems((prev) =>
      prev.map((i) =>
        i.id === id ? { ...i, license, price: license === "commercial" ? i.basePrice * 3 : i.basePrice } : i
      )
    );
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const inCart = useCallback((id) => items.some((i) => i.id === id), [items]);

  const subtotal = items.reduce((s, i) => s + i.price, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, setLicense, clear, inCart, subtotal, open, setOpen, count: items.length }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
